export default {
  emptyDataMsg_1: '조회된 데이터가 없습니다',
};
